import React, {useEffect, useState} from 'react';
import {makeApiCall} from '../../../Api/makeApiCall';
import logo from '../../../assets/spins-logo.svg';
import TokenExpirationTimer from '../../../auth/components/TokenExpirationTimer';
import HeaderDropdown, {SEPARATOR} from './HeaderDropdown';
import TitleDropdown from '../TitleDropdown';
import NextPeriod from '../../../auth/components/NextPeriod';
import {getGreetingDisplay, getUserEmail} from '../../../auth/accessTokenValidator';
import {userAvatars} from './userAvatars';
import SearchBar from '../SearchBar';
import {forceLogout} from "../../../auth/url";
import {
    nestedGeographyContent,
    nestedMarketContent,
    nestedOutliersContent,
    nestedProduceServiceContent,
    nestedProjectionsContent,
    nestedRetailerConfigurationsContent,
    nestedRetailerManagementContent,
    nestedStoreContent
} from "../../Management/nestedHeaderSubmenus";

export const Header = ({routes}) => {

    const [unmappedRetailers, setUnmappedRetailers] = useState(undefined);

    useEffect(() => {
        const endpointUrl = `${process.env.REACT_APP_EDP_API_BASE_URL}/unmappedRetailers/`;
        makeApiCall(endpointUrl).then(result => {
            const foo = result?.metadata?.length || 0;
            setUnmappedRetailers(foo);
        });
    }, []);

    const avatarUrl = userAvatars[getUserEmail()?.replace(/@.*$/, '')];

    return (
        <>
            <div className={`App App-${process.env.REACT_APP_ENV}`}>
                <div className={'title-bar-container'}>
                    <div className={'header-section'}>
                        <a href='/public'><img src={logo} alt={'SPINS logo'} className={"columns small-1 spins-logo"}
                                               data-testid={'spins-logo'}/></a>
                        <a href='/public'>
                            <div className={'dashboard-title'}>Dashboard</div>
                        </a>
                    </div>
                    <div className={'header-section'}>
                        <SearchBar routes={routes}/>
                        <div className={'header-next-period'}>
                            <NextPeriod/>
                        </div>
                        <div className={'header-session-timeout'}>
                            <TokenExpirationTimer onTimerExpiration={forceLogout}
                                                  labelValue={'Session Expires In:'}
                                                  tokenAccessor={'access_token'}
                                                  sessionType={'Dashboard'}
                            />
                        </div>
                        <div className={'header-session-user'}>
                            {getGreetingDisplay()}
                            {avatarUrl && <img src={avatarUrl} alt={'user avatar'} referrerPolicy={'no-referrer'}
                                               className={'header-session-user-avatar'}/>}
                        </div>
                        <TitleDropdown/>
                    </div>
                </div>
            </div>
            <div className={'nav-bar'}>
                <div className={"nav-title-bar"}>
                    <nav className={"nav z-to-the-top"} data-animate="hinge-in-from-top spin-out">
                        <ul className="dropdown menu columns small-12 header-dropdowns" data-dropdown-menu={true}>
                            <HeaderDropdown
                                title={"Logs"}
                                menuItems={[
                                    {name: "File Logs", url: "/ingestedLogs"},
                                    {name: "Processing Logs", url: "/processingLogs"}
                                ]}
                            />
                            <HeaderDropdown
                                title={"Alerts"}
                                menuItems={[
                                    {name: "Missing Data", url: "/alerts/missingData"},
                                    {name: "Missing Days", url: "/alerts/missingDays"},
                                    {name: "Missing Weeks", url: "/alerts/missingWeeks"},
                                    {name: "Outliers", url: "#", nestedContent: nestedOutliersContent},
                                    {name: "Past Due", url: "/alerts/pastDue"},
                                    {name: "Summary", url: "/alerts/summary"}
                                ]}
                            />
                            <HeaderDropdown
                                title={"Retailer Readiness"}
                                menuItems={[
                                    {name: "Completeness", url: "/retailerReadiness/completeness"},
                                    {
                                        name: "Fill All: Multi Retailer",
                                        url: "/retailerReadiness/fillAllMultipleRetailers"
                                    },
                                    {name: "Generate: Promo", url: "/retailerReadiness/promo"},
                                    {name: "Period Release Checkpoint", url: "/periodReleaseCheckpoints"},
                                    {name: "Sales By Market Tag", url: "/salesByMarketTag"},
                                    {name: "Store Totals", url: "/retailerReadiness/storeTotals"},
                                    {name: "What Will Fill", url: "/continuity/whatWillFill"},
                                ]}
                            />
                            <HeaderDropdown
                                title={"Store Insights"}
                                menuItems={[
                                    {
                                        name: "Generate",
                                        url: "/storeInsights/generate"
                                    },
                                    {
                                        name: "Readiness",
                                        url: "/storeInsights/readiness"
                                    }
                                ]}
                            />
                            <HeaderDropdown
                                title={"Market Insights"}
                                menuItems={[
                                    {name: "Checklist", url: "/marketInsights/checklist"},
                                    {name: "Readiness", url: "/marketInsights/readiness"},
                                    SEPARATOR,
                                    {name: "Generate", url: "/marketInsights/generate"},
                                    {name: "Release", url: "/marketInsights/release"},
                                    SEPARATOR,
                                    {name: "Comparison Report", url: "/comparisonReportPage"},
                                    {name: "Publish", url: "/scaffoldingPublish"},
                                    {name: "Spotlight: Cleanse Fill", url: "/extractSpotlight"},
                                    SEPARATOR,
                                    {name: "Extracts", url: "/nucleusExtractsTriggerDag"},
                                ]}
                            />

                            <div className={'divider'}/>
                            <HeaderDropdown
                                title={"Management"}
                                menuItems={[
                                    {name: "Checkpoints", url: "/checkpoints"},
                                    {name: "Custom Hierarchies", url: "/customHierarchyRetailers"},
                                    {name: "Providers", url: "/providersService"},
                                    {name: "Retailers", url: "#", nestedContent: nestedRetailerManagementContent},
                                    {name: "System", url: "/system"},
                                ]}
                            />
                            <HeaderDropdown
                                title={"Configurations"}
                                menuItems={[
                                    {name: "Alerts", url: '/alertsConfigurations'},
                                    {name: "Checkpoint Types", url: "/checkPointTypesService"},
                                    {name: "File Exclusion", url: "/fileExclusion"},
                                    {name: "FTP", url: "/ftpConfigurations"},
                                    {name: "Retailer", url: "#", nestedContent: nestedRetailerConfigurationsContent},
                                    {name: "Store", url: "#", nestedContent: nestedStoreContent},
                                    {name: "Toast Clients", url: "/toastClients"},
                                ]}
                            />
                            <div className={'divider'}/>
                            <HeaderDropdown
                                title={"Unmapped"}
                                menuItems={[
                                    {name: "Ignored FTPs", url: "/ignoredFTPsService"},
                                    {
                                        name: "Ignored Stores",
                                        url: "/ignoreUnmappedStoreService",
                                    },
                                    {
                                        name: "Retailers",
                                        url: "/unmappedRetailers",
                                        additionalContent: unmappedRetailers > 0 ?
                                            <span data-testid={'unmapped-retailers'}
                                                  className="badge alert badge-retailers">{unmappedRetailers}</span> : <></>
                                    },
                                    {
                                        name: "Stores",
                                        url: "/unmappedStores",
                                    }
                                ]}
                            />
                            <HeaderDropdown
                                title={"Services"}
                                menuItems={[
                                    {name: "Designations", url: "/designations"},
                                    {name: "Geography", url: "#", nestedContent: nestedGeographyContent},
                                    {name: "Incoming Files", url: "/incomingFiles"},
                                    {name: "Market", url: "#", nestedContent: nestedMarketContent},
                                    {name: "Produce", url: "#", nestedContent: nestedProduceServiceContent},
                                    {name: "Projections", url: "#", nestedContent: nestedProjectionsContent},
                                    {name: "Remove Measures", url: "/removeMeasures"},
                                    {name: "Store", url: "/storeService"},
                                    {name: "Time", url: "/timeService"},
                                ]}
                            />
                            <HeaderDropdown
                                title={"Scaffolding"}
                                menuItems={[
                                    {name: "Cleansed Data Csv Extracts", url: "/extractTriggerCleanseDataCsv"},
                                    {name: "Extracts", url: "/scaffoldingExtractsTriggerDag"},
                                ]}
                            />
                            <HeaderDropdown
                                title={"Circana"}
                                menuItems={[
                                    {name: "Conventional Data QC", url: "/conventionalDataQC"},
                                    {name: "Conventional Data Unload", url: "/conventionalDataUnload"},
                                ]}
                            />
                            <HeaderDropdown
                                title={"Stackline"}
                                menuItems={[
                                    {name: "Stackline Process", url: "/stacklineProcess"},
                                ]}
                            />
                            <HeaderDropdown
                                title={"MAP Enforcement"}
                                menuItems={[
                                    {name: "Brand Onboarding", url: "/brandOnboarding"},
                                    {name: "MAP Enforcement", url: "/mapEnforcementDashboard"},
                                    {name: "Merchant Search", url: "/merchantSearch"},
                                ]}
                            />
                            <HeaderDropdown
                                title={"ADP"}
                                menuItems={[
                                    {name: "ADP Publish", url: "/advancedDataPlatformPublish"},
                                    {name: "Geo/Market Publishing", url: "/adpGeoMarketPublish"},
                                    {name: "Measures Publishing", url: "/adpMeasuresPublish"},
                                    {name: "PI Engine Snapshot", url: "/piEngineSnapshot"},
                                ]}
                            />
                        </ul>
                    </nav>
                </div>
            </div>
        </>
    )
}
